<template lang="html">
  <section class="display-payload">
    <div class="page page-with-nav">
      <div class="card-wrapper">
        <div class="page-content">
          <div class="container text-left">
            <div class="col-12">
              <vue-markdown class="aria-markdown-wrapper">
                {{language.text}}
              </vue-markdown>

              <div class="feedback-cta-wrapper right">
                <div class="feedback-ctas">
                  <a href="#showDashboard"
                     style="background-color: #0073E6;"
                     class="aria-cta cta-filled">
                    {{language.showDashboardText}}
                  </a>
                </div>
                <div class="feedback-ctas">
                  <a href="#takeTest"
                     style="background-color: #0073E6;"
                     class="aria-cta cta-filled">
                    {{language.takeTestText}}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="js">
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    VueMarkdown
  },
  props: ['language_abbr'],
  data() {
    const langs = {
      'en': {
        'text': '\n## Hi, it\'s NuvoAir Home here! \n### What can I help you with?',
        'showDashboardText': 'Show Dashboard',
        'takeTestText': 'Take a Test'
      },
      'de': {
        'text': '\n## Hallo, NuvoAir Home hier! \n### Kann ich sonst noch etwas für Sie tun?',
        'showDashboardText': 'Zur Übersicht',
        'takeTestText': 'Test machen'
      },
      'es': {
        'text': '\n## ¡Hola, soy NuvoAir Home! \n### ¿Le puedo ayudar en alguna otra cosa?',
        'showDashboardText': 'Mostrar inicio',
        'takeTestText': 'Haga la prueba'
      },
      'fr': {
        'text': '\n## Bonjour, mois c\'est NuvoAir Home! \n### Y a-t-il autre chose que je puisse faire pour vous ?',
        'showDashboardText': 'Afficher le tableau de bord',
        'takeTestText': 'Faire un test'
      },
      'it': {
        'text': '\n## Ciao, eccomi, sono NuvoAir Home! \n### Posso fare altro?',
        'showDashboardText': 'Pannello',
        'takeTestText': 'Inizia test'
      },
      'nl': {
        'text': '\n## Hallo, dit is NuvoAir Home! \n### Kan ik u nog ergens anders mee helpen?',
        'showDashboardText': 'Dashboard',
        'takeTestText': 'Take a Test'
      },
      'se': {
        'text': '\n## Hej, det är NuvoAir Home! \n### Finns det något jag kan hjälpa dig med?',
        'showDashboardText': 'Visa dashboard',
        'takeTestText': 'Genomför test'
      }
    };

    return {
      language: langs[this.language_abbr] || langs.en
    };
  }
}
</script>

<style scoped lang="scss">
  .display-payload {
      .pre-line-text {
          white-space: pre-line;
      }
  }
  .feedback-ctas {
      display: inline;
  }

  p {
      font-size: 17px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/DisplayPayload.vue